export const TOAST_POSITION = 'top-right' as const

export const FLOW_COPY_SUFFIX = ' (Copy)'

export const DEFAULT_SCOPE = 'GLOBAL'

export const ADMIN_ROLES = ['superAdmin', 'accountManager', 'subAdmin', 'sales', 'affiliate'] as const

export const MENU_ICONS = {
  VIEW_ACTIVITY: 'bi bi-eye me-2',
  EDIT: 'bi bi-pencil-square me-2',
  DUPLICATE: 'bi bi-files me-2',
  SETTINGS: 'bi bi-gear me-2',
  PAUSE: 'bi bi-pause-circle me-2',
  PLAY: 'bi bi-play-circle me-2',
  RESUME: 'bi bi-arrow-clockwise me-2',
  DELETE: 'bi bi-trash me-2',
} as const

export const ROUTES = {
  AUTOMATION_FLOW: (id: string) => `/automation/flow/${id}`,
  TEMPLATE_AUTOMATION_FLOW: (id: string) => `/templates/automation/flow/${id}`,
  CONTACTS_IN_FLOWS: (id: string) => `/automation/contacts-in-flows/${id}`,
  FLOW_REPORT: (id: string) => `/report-analytics/flow/report/${id}`,
} as const

